export interface InferenceMetrics {
  lastActivity?: string
  ready?: boolean
  unresponsive?: boolean
  updatedAt?: string
}

export enum InferenceStates {
  Failed = 'Failed',
  Healthy = 'Healthy',
  Preparing = 'Preparing',
  StillWaiting = 'Still looking for resources...',
  Stopped = 'Stopped',
  Stopping = 'Stopping',
  Unknown = 'Unknown',
  Unresponsive = 'Robovision AI cannot connect to instance',
  Waiting = 'Waiting for resources',
}
